const AUTH_TOKEN_STORAGE_KEY = "testjob.authToken";

export function getAuthToken() {
  if (typeof window === "undefined") {
    return "";
  }
  try {
    return window.localStorage.getItem(AUTH_TOKEN_STORAGE_KEY) || "";
  } catch (error) {
    return "";
  }
}

export function setAuthToken(token) {
  if (typeof window === "undefined") {
    return;
  }
  try {
    if (token) {
      window.localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token);
    } else {
      window.localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
    }
  } catch (error) {
    // Local storage is optional; API errors will make the missing token visible.
  }
}

export function authHeaders(headers = {}) {
  const token = getAuthToken();
  return {
    ...headers,
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

// Shared fetch wrapper. Domain API modules build on this function so stores
// and pages do not need to know raw endpoint paths.
export async function api(path, options = {}) {
  const headers = authHeaders({
    "Content-Type": "application/json",
    ...(options.headers || {}),
  });
  const response = await fetch(path, {
    ...options,
    headers,
  });
  const data = await response.json();
  if (!response.ok) {
    const message = data.detail
      ? `${data.error || "请求失败"}：${data.detail}`
      : data.error || "请求失败";
    throw new Error(message);
  }
  return data;
}
